import React, { useState } from 'react';
import AdminUsersEditPageLegacy from './AdminUsersEditPageLegacy';
import AdminUsersEditPageV2 from './AdminUsersEditPageV2';

// Per-browser choice between the classic account page and the new two-column one. Classic is the default
// so support is not switched over by surprise; the header of each page carries the toggle.
const LAYOUT_KEY = 'adminAccountPageLayout';
type Layout = 'classic' | 'v2';

const readLayout = (): Layout => {
  try {
    return localStorage.getItem(LAYOUT_KEY) === 'v2' ? 'v2' : 'classic';
  } catch {
    return 'classic';
  }
};

const AdminUsersEditPage: React.FC = () => {
  const [layout, setLayout] = useState<Layout>(readLayout);

  const switchLayout = () => {
    const next: Layout = layout === 'v2' ? 'classic' : 'v2';
    try {
      localStorage.setItem(LAYOUT_KEY, next);
    } catch {
      // Private mode or blocked storage: the choice just does not persist.
    }
    setLayout(next);
  };

  return layout === 'v2' ? (
    <AdminUsersEditPageV2 onSwitchLayout={switchLayout} />
  ) : (
    <AdminUsersEditPageLegacy onSwitchLayout={switchLayout} />
  );
};

export default AdminUsersEditPage;
